import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/timeslot.py TimeslotOut.
export interface TimeslotPreset {
  timeslot_preset_id: number;
  name: string;
  allowed_timeslot: string | null; // "08:00,21:00"
  allowed_weekday: string | null; // PHP convention 1=Sun..7=Sat, e.g. "2,3,4,5,6"
  active: boolean;
}

export interface TimeslotInput {
  name: string;
  allowed_timeslot: string;
  allowed_weekday: string;
  active: boolean;
}

export async function listTimeslots(): Promise<TimeslotPreset[]> {
  const resp = await api.get<APIResponse<TimeslotPreset[]>>("/timeslots/");
  return unwrap(resp.data);
}

export async function createTimeslot(body: TimeslotInput): Promise<number> {
  const resp = await api.post<APIResponse<{ timeslot_preset_id: number }>>("/timeslots/", body);
  return unwrap(resp.data).timeslot_preset_id;
}

export async function updateTimeslot(id: number, body: TimeslotInput): Promise<void> {
  await api.put(`/timeslots/${id}`, body);
}

export async function deleteTimeslot(id: number): Promise<void> {
  await api.delete(`/timeslots/${id}`);
}
